import React from 'react';
import { Link } from '@sitecore-jss/sitecore-jss-react'; // Constants

import * as CONSTANTS from '../../../constants';
import { SitecoreLink } from '../../link/Link'; //ga tracker

import gaTracker from '../../../util/ga-analytics/gaTracker';

var gaLink = function gaLink(value) {
  var data = {
    gtm: {
      uniqueEventId: '47',
      elementTarget: value.href,
      elementTitle: value.title,
      elementId: "card-".concat(value === null || value === void 0 ? void 0 : value.id)
    },
    event: 'gtm.click'
  };
  gaTracker(data);
};

var CTALink = function CTALink(props) {
  var _props$ctaLink = props.ctaLink,
      ctaLink = _props$ctaLink === void 0 ? {} : _props$ctaLink,
      _props$linkType = props.linkType,
      linkType = _props$linkType === void 0 ? '' : _props$linkType,
      containerClass = props.containerClass,
      alignment = props.alignment,
      id = props.id,
      _props$onClick = props.onClick,
      _onClick = _props$onClick === void 0 ? gaLink : _props$onClick;

  var _ctaLink$value = ctaLink.value,
      value = _ctaLink$value === void 0 ? {} : _ctaLink$value;
  var linkClass = linkType !== 'default' ? "cb-cta-default" : CONSTANTS.BANNER_PRIMARY_BUTTON;
  var className = "".concat(value.class, " ").concat(linkClass);
  var wrapperClass = "cb-l-copy-wrapper--".concat(alignment);

  if (typeof alignment !== 'undefined' && alignment === 'center') {
    wrapperClass = 'cb-l-copy-wrapper';
  }

  return value.href ? /*#__PURE__*/React.createElement("div", {
    className: "\n        cb-type--".concat(alignment === 'center' ? alignment : 'left', " ").concat(containerClass, "\n        ").concat(wrapperClass, "\n        ")
  }, /*#__PURE__*/React.createElement(SitecoreLink, {
    field: ctaLink,
    showLinkTextWithChildrenPresent: "true",
    className: className,
    id: "card-".concat(value === null || value === void 0 ? void 0 : value.id) || id,
    onClick: function onClick() {
      return _onClick(value);
    }
  })) : null;
};

export default CTALink;